import React from 'react';

const IngredientOptionsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        {...props}
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 16-3 0m3 0a1.5 1.5 0 00-3 0m-3 0H3.75m13.5-6H21m-11.25 0H3.75m11.25 0a1.5 1.5 0 113 0m-3 0a1.5 1.5 0 103 0"
        />
    </svg>
);

export default IngredientOptionsIcon;
